module.exports = __webpack_public_path__ + "static/media/Raleway-Regular.145cf3f6.woff";